import React, { useEffect, useRef, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const VenueHighlightSection = () => {
  const [venuesData, setVenuesData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState(null);

  const modalRef = useRef(null);

  const fetchVideoData = async () => {
    try {
      const response = await corefetch(`Facility/GetVenueHighlightsSection`);
      if (response) {
        setVenuesData(response);
      } else {
        console.error("No venue data received.");
      }
    } catch (error) {
      setVenuesData("");
      console.error("Failed to fetch video data", error);
    }
  };

  useEffect(() => {
    fetchVideoData();
  }, []);

  useEffect(() => {
    if (venuesData?.length) {
      const $carousel = $(".service-slider");

      $carousel.owlCarousel({
        autoplay: true,
        smartSpeed: 300,
        margin: 0.5,
        loop: true,
        lazyLoad: true,
        autoplayHoverPause: true,
        dots: false,
        arrows: false,
        nav: false,
        center: true,
        autoWidth: false,
        autoHeight: true,
        items: 5,
        navText: [
          '<i class="ti-arrow-left"></i>',
          '<i class="ti-arrow-right"></i>',
        ],
        responsive: {
          0: { items: 1, dots: false, arrows: false, nav: false },
          575: { items: 1 },
          767: { items: 1, dots: false },
          992: { items: 5, dots: false },
          1200: { items: 5 },
        },
      });

      $carousel.on("click", ".venueImg", function () {
        const data = $(this).attr("data-venue");
        if (data) {
          const venue = JSON.parse(decodeURIComponent(data));
          setSelectedVenue(venue);
          setIsModalOpen(true);
        }
      });

      return () => {
        $carousel.trigger("destroy.owl.carousel");
        $carousel.off("click", ".venueImg");
      };
    }
  }, [JSON.stringify(venuesData)]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (!venuesData || venuesData.length === 0) return null;

  return (
    <section className="wpo-Service-section-s2 sec-padding1">
      <h2 className="hidden">Venue Highlights</h2>
      <div className="container-fluid">
        <div className="wpo-section-title">
          <h4>Venue Details</h4>
        </div>
        <div className="wpo-Service-wrap">
          <div className="service-slider owl-carousel">
            {venuesData.map((venue) => (
              <div className="wpo-Service-item" key={venue.facilityID}>
                <div className="wpo-Service-img">
                  <img
                    className="venueImg"
                    src={`${ImageURL}${venue.oldImagePath}`}
                    alt={venue.facilityName}
                    data-venue={encodeURIComponent(JSON.stringify(venue))}
                  />
                </div>
                <div className="wpo-Service-text">
                  <a
                    href={`/facilityMain/${venue.facilityID}`}
                    className="venue"
                  >
                    {venue.facilityName.split(" ")[0]}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal for Venue Details */}
      {isModalOpen && selectedVenue && (
        <div className="popup">
          <div className="modal-content venues" ref={modalRef}>
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header venues">
              <div className="col-6">{selectedVenue.facilityName}</div>
              <div className="col-6 d-flex mt-4 custom-font">
                <div className="col-8 text-center">
                  <a
                    className="theme-btn"
                    href={selectedVenue.detailedView}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Virtual Tour
                  </a>
                </div>
                <div className="col-4">
                  <a
                    className="theme-btn"
                    href={`/gallery/${selectedVenue.facilityID}/BallRoom`}
                  >
                    Gallery
                  </a>
                </div>
              </div>
            </div>
            <div className="additional-text">
              <p>{selectedVenue.description || "No description available."}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default VenueHighlightSection;
